import { css } from "@emotion/react";

import "antd/lib/style/themes/default.less";
import "antd/dist/antd.less";

export const media = (width, style) =>
  css`
    @media (max-width: ${width}) {
      ${style};
    }
  `;

const library = (theme) => css`
  .ant-select-item-option-content {
    font-size: 12px;
  }

  .ant-select-selection-placeholder {
    font-size: 12px;
    line-height: 24px !important;
  }

  .ant-result {
    padding: 0px;
  }
`;

export default library;
